export const comments_3399192 = {"data":{"data":[],"links":{}}}